import { render, staticRenderFns } from "./FormInputGroup.vue?vue&type=template&id=27a84e24"
import script from "./FormInputGroup.vue?vue&type=script&lang=js"
export * from "./FormInputGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports